<div class="search-wrapper" [class.focused]="focused()" [class.has-value]="value()">
  <ptl-icon class="search-icon" icon="search" size="xs" />
  <input
    type="text"
    class="search-input"
    [value]="value()"
    [placeholder]="placeholder()"
    (input)="onInput($event)"
    (focus)="focused.set(true)"
    (blur)="focused.set(false)"
  />
</div>
